import React, { useEffect, useState } from "react";
import { Button, Card, Form, InputGroup } from "react-bootstrap";
import { toast } from "react-toastify";
import { commonToast } from "../../Utils";
import { LoadingButton, SpinnerBlock } from "../../Utils/CustomComponent";
import useCredentials from "./useCredentials";

const ApiDocumentation = () => {
  const [disableBtn, setDisableBtn] = useState(false);
  const { getCredentials, credentials, loading, links, loadingLinks } =
    useCredentials();

  useEffect(() => {
    if (!loading && disableBtn) {
      setDisableBtn(false);
    }
  }, [loading, disableBtn]);

  async function handleRegenerate() {
    setDisableBtn(true);
    getCredentials();
  }

  return (
    <div>
      <section
        className="rounded container-fluid"
        style={{ background: "#eeeeee", minHeight: "100vh" }}
      >
        <div className="p-3 pb-0  mt-1">
          <h4 className="mt-4 mb-3">API Documentation</h4>
          <div
            className="p-5"
            style={{
              backgroundColor: "#fff",
              borderRadius: "8px",
            }}
          >
            <div>
              <h5>Reset API Credentials</h5>
              <p className="my-5">
                API credentials for the client IO newendpoint
              </p>
              <div>
                {loading ? (
                  <div>
                    <SpinnerBlock height="50vh" />
                  </div>
                ) : (
                  <>
                    <CopyBox text={credentials?.clientId} label={"Client ID"} />
                    <CopyBox
                      text={credentials?.clientSecret}
                      label="Client Secret"
                    />
                  </>
                )}
                <LoadingButton
                  type="button"
                  className="btn btn-primary my-3 text-white"
                  onClick={handleRegenerate}
                  title={"Regenerate"}
                  disabled={loading}
                  loading={disableBtn}
                />
              </div>

              <div className="d-flex my-5 gap-5">
                <CardBox
                  title="New Loan API Documentation"
                  body="API documentation for the new loan endpoint"
                  className={"w-100"}
                  downloadLink={links?.[0]}
                  disabled={loadingLinks}
                />
                <CardBox
                  title="Payment API Documentation"
                  body="API documentation for the payment endpoint"
                  className={"w-100"}
                  downloadLink={links?.[1]}
                  disabled={loadingLinks}
                />
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ApiDocumentation;

const CopyBox = ({ text, label }) => {
  const [btnText, setBtnText] = useState("Copy");
  let copyTimeout;

  const handleCopy = async (text) => {
    try {
      setBtnText("Copied");
      clearTimeout(copyTimeout); // Clear any existing timeout

      await navigator.clipboard.writeText(text);
      toast.success("Copied to clipboard", {
        ...commonToast,
      });

      copyTimeout = setTimeout(() => {
        setBtnText("Copy");
      }, 2000);
    } catch (err) {
      toast.error("Failed to copy", {
        ...commonToast,
        autoClose: 2000,
      });
    }
  };

  return (
    <Form.Group className="my-5">
      <Form.Label>{label}</Form.Label>
      <InputGroup className="border border-2 bg-grey">
        <Form.Control
          value={text}
          readOnly
          className="text-muted bg-grey border border-0"
        />
        <div className="bg-grey">
          <Button
            variant="btn btn-primary text-white mx-5 my-3"
            onClick={() => handleCopy(text)}
          >
            {btnText}
          </Button>
        </div>
      </InputGroup>
    </Form.Group>
  );
};

const CardBox = ({ title, body, className, downloadLink, disabled }) => {
  function handleDownload() {
    const link = document.createElement("a");
    link.href = downloadLink?.url;
    link.target = "_blank"; // Opens in new tab
    link.rel = "noopener noreferrer"; // Security best practices
    document.body.appendChild(link); // Required for Firefox
    link.click();
    document.body.removeChild(link);
  }

  return (
    <Card className={`p-5 ${className}`}>
      <Card.Body>
        <Card.Title>{title}</Card.Title>
        <Card.Text className="my-3">{body}</Card.Text>
        <Button
          variant="primary mt-5 text-white"
          onClick={handleDownload}
          disabled={disabled || !downloadLink}
        >
          Download
        </Button>
      </Card.Body>
    </Card>
  );
};
